// extracted by mini-css-extract-plugin
module.exports = {"Toggle":"Toggle_Toggle__bng1V","Toggle__container":"Toggle_Toggle__container__OBCSk","Toggle__slider":"Toggle_Toggle__slider__nf88e"};